import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import constants from '../../../config/constants'
import { request } from '../../../_network/request'
import { subscriptionsURLs, serviceConfigsURLs } from '../../../_network/apiUrls'
import { sortByPriority } from '../_helpers/sort'
import ProgressWrapper from './ProgressWrapper'
import SelectProductWrapper from './SelectProductWrapper'
import SelectSubscriptionWrapper from './SelectSubscriptionWrapper'
import ConfigWrapper from './ConfigWrapper'
import SubmitWrapper from './SubmitWrapper'

const SubscriptionAddWrapper = (props) => {
  const { supportedPaymentMethods, subscriptionGroupNames } = props
  const theme = useTheme()

  const progress_step = useSelector(state => state.subscriptionAdd.progress_step)
  const group = useSelector(state => state.subscriptionAdd.group)
  const subscription_package = useSelector(state => state.subscriptionAdd.subscription_package)
  const subscription_renewable = useSelector(state => state.subscriptionAdd.subscription_renewable)
  
  const [step, setStep] = useState(progress_step ? progress_step : 1)
  const [subscriptionGroupsData, setSubscriptionGroupsData] = useState([])
  const [subscriptionPackagesData, setSubscriptionPackagesData] = useState([])
  const [supportedServiceConfigs, setSupportedServiceConfigs] = useState([])
  const [subscriptionPackages, setSubscriptionPackages] = useState([])
  
  const [selectedProduct, setSelectedProduct] = useState(group)
  const [selectedSubscription, setSelectedSubscription] = useState(null)  
  const [selectedServices, setSelectedServices] = useState([])
  const [totalFee, setTotalFee] = useState(0)

  const [appCredentialSecret, setAppCredentialSecret] = useState('')
  const [paymentMethodIds, setPaymentMethodIds] = useState(null)
  
  const wrapperStyle = {
    margin: '40px 20px',
    background: theme.palette.aliceBlue,
    borderRadius: '20px',
    padding: '20px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  }

  const scrollToTop = () => {
    // const element = document.getElementById('wrapperStart')
    // element.scrollIntoView({ behavior: 'smooth' })
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    scrollToTop()
  }, [step])

  useEffect(() => {
    const fetchSupportedServiceConfigsData = async () => {
      const url = constants.core_service_domain + '/' + serviceConfigsURLs.getSupportedServiceConfigs
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSupportedServiceConfigs(response.data)
      } else {
        setSupportedServiceConfigs([])
      }
    }

    fetchSupportedServiceConfigsData()
  }, [])

  useEffect(() => {
    const fetchSubscriptionGroupsData = async () => {
      const url = constants.core_service_domain + '/' + subscriptionsURLs.getSubscriptionGroups
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSubscriptionGroupsData(sortByPriority(response.data))
      } else {
        setSubscriptionGroupsData([])
      }
    }

    fetchSubscriptionGroupsData()
  }, [])

  useEffect(() => {
    const fetchSubscriptionPackagesData = async () => {
      const url = constants.core_service_domain + '/' + subscriptionsURLs.getSubscriptionPackages
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSubscriptionPackagesData(sortByPriority(response.data.filter(item => item.group === selectedProduct)))
      } else {
        setSubscriptionPackagesData([])
      }
    }

    if (selectedProduct) {
      fetchSubscriptionPackagesData()
    } else {
      setSubscriptionPackagesData([])
    }    
  }, [selectedProduct])

  useEffect(() => {
    const getSubscriptionChecked = (id) => {
      return subscription_package && subscription_package.id && subscription_package.id === id
    }

    const getServiceChecked = (subscription_checked, service) => {
      let result = false

      if (subscription_checked && subscription_package && subscription_package.services) {
        const service_object = subscription_package.services.find(item => item.service === service)
        if (service_object) {
          return true
        }
      }

      return result
    }

    let subscription_packages = []

    subscriptionPackagesData.forEach(p => {
      let services = []
      const subscription_checked = getSubscriptionChecked(p.id)

      p.services.forEach(s => {
        services.push({
          ...s,
          checked: s.is_mandatory ? true : getServiceChecked(subscription_checked, s.service),
        })
      })

      subscription_packages.push({
        ...p,
        checked: subscription_checked,
        renewable: subscription_checked ? subscription_renewable : true,
        services,
      })
    })

    setSubscriptionPackages(subscription_packages)
  }, [subscriptionPackagesData, subscription_package, subscription_renewable])  
  
  useEffect(() => {
    const subscription_object = subscriptionPackages.find(item => item.checked)
    setSelectedSubscription(subscription_object ? subscription_object.id : null)
  }, [subscriptionPackages])

  useEffect(() => {
    let total_fee = 0
    let selected_services = []

    const subscription_object = subscriptionPackages.find(item => item.checked)

    if (subscription_object) {
      total_fee = parseFloat(subscription_object.base_price)

      subscription_object.services.forEach(s => {
        if (!s.is_mandatory && s.checked) {
          total_fee = total_fee + parseFloat(s.price)
        }
      })

      const subscription_data_object = subscriptionPackagesData.find(item => item.id === subscription_object.id)

      if (subscription_data_object && subscription_data_object.services) {
        subscription_data_object.services.forEach(s => {
          if (s.is_mandatory) {
            selected_services.push(s)
          } else {
            const selected_service_object = subscription_object.services.find(item => item.service === s.service && item.checked)
            if (selected_service_object) {
              selected_services.push(s)
            }
          }
        })
      }
    }

    setTotalFee(total_fee)
    setSelectedServices(selected_services)
  }, [subscriptionPackages, subscriptionPackagesData])
  
  return (
    <Box sx={wrapperStyle} id='wrapperStart'>
      <ProgressWrapper step={step} />

      {
        step === 1 &&
        <SelectProductWrapper
          setStep={setStep}
          subscriptionGroupsData={subscriptionGroupsData}
          subscriptionGroupNames={subscriptionGroupNames}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}          
        />
      }

      {
        step === 2 &&
        <SelectSubscriptionWrapper
          setStep={setStep}
          subscriptionPackagesData={subscriptionPackagesData}
          subscriptionPackages={subscriptionPackages}
          setSubscriptionPackages={setSubscriptionPackages}
        />
      }

      {
        step === 3 &&
        <ConfigWrapper
          setStep={setStep}
          selectedServices={selectedServices}
          supportedServiceConfigs={supportedServiceConfigs}
          supportedPaymentMethods={supportedPaymentMethods}
          appCredentialSecret={appCredentialSecret}
          setAppCredentialSecret={setAppCredentialSecret}
          paymentMethodIds={paymentMethodIds}
          setPaymentMethodIds={setPaymentMethodIds}
        />
      }

      {
        step === 4 &&
        <SubmitWrapper
          setStep={setStep}
          totalFee={totalFee}
          subscriptionPackagesData={subscriptionPackagesData}
          selectedSubscription={selectedSubscription}
          supportedPaymentMethods={supportedPaymentMethods}
          supportedServiceConfigs={supportedServiceConfigs}
          appCredentialSecret={appCredentialSecret}
          paymentMethodIds={paymentMethodIds}
        />
      }
    </Box>
  )
}

export default SubscriptionAddWrapper